import Text from 'components/base/Text'
import styled from 'styled-components'
import css from '@styled-system/css'

export const Reason = styled(Text).attrs({ as: 'li' })`
  line-height: 1.428571429;
  & > a {
    text-decoration: none;
    ${css({
      color: 'primary.600',
    })}
  }

  & > a:hover {
    text-decoration: underline;
    ${css({
      color: 'primary.800',
    })}
  }
`
